import t from 'tcomb-form';
import {ValidationError} from 'validators';
import validUrl from 'validate.io-uri';


export default t.subtype(t.Str, (n) => {
    try {
        let url = n.toLowerCase().startsWith('http://') || n.toLowerCase().startsWith('https://') ? n : 'http://' + n;
        if (!!validUrl(url)) {
            return true;
        } else {
            throw ValidationError;
        }
    }

    catch(e) {
        if (e instanceof ValidationError) {
            return false;
        }

        return false;
    }
});



/** WEBPACK FOOTER **
 ** ./app/src/forms/validators/url.js
 **/